import React, { Fragment } from 'react'
import './style.css'

export default function CommonAppSupport(props) {
    return (
        <div className='Home_SpaceBasedPlan'>
            <div className='Home_SpaceBasedPlan_MainTitle'>共性应用支撑平台</div>
            <div className='Home_SpaceBasedPlan_FirstTitle'>平台简介</div>
            <div className='Home_SpaceBasedPlan_FirstMain'>
                <div className='Home_SpaceBasedPlan_MainIntroduceText'>国家民用空间基础设施陆地观测卫星共性应用支撑平台是《国家民用空间基础设施中长期规划（2015-2025 年）》的重要组成部分。目前，面向空基“十二五”、“十三五”阶段的12型24颗陆地观测卫星，建成了包括48个真实性检验站、6个综合实验场在内的国家级真实性检验场网系统、共性技术支撑服务系统。</div>
            </div>
            <div className='Home_SpaceBasedPlan_Imgs2'>
                <img className='Home_SpaceBasedPlan_Img1' src="images/Introduce/CommonAppSupport/1.png" />
            </div>
            <div className='Home_SpaceBasedPlan_FirstMain'>
                <div className='Home_SpaceBasedPlan_MainIntroduceText'>平台能够为行业、区域、科教、大众等用户提供卫星共性产品检验、共性技术测评以及共性资源共享等服务。 共享资源及服务模式如下：</div>
            </div>
            <div className='Home_SpaceBasedPlan_Imgs2'>
                <img className='Home_SpaceBasedPlan_Img2' src="images/Introduce/CommonAppSupport/2.png" />
            </div>

            <div className='Home_SpaceBasedPlan_FirstTitle'>真实性检验场网系统</div>
            <div className='Home_SpaceBasedPlan_FirstMain'>
                <div className='Home_SpaceBasedPlan_MainIntroduceText'>真实性检验场网系统由以下部分组成：光学微波卫星真实性检验站网、电磁卫星真实性检验站网、综合试验场、基准和综合实验室，形成多谱段、多手段、场站结合、室内外一体化的地面真值采集系统。</div>
            </div>
            <div className='Home_SpaceBasedPlan_Imgs2'>
                <img className='Home_SpaceBasedPlan_Img3' src="images/Introduce/CommonAppSupport/3.png" />
            </div>

            <div className='Home_SpaceBasedPlan_FirstTitle'>共性应用技术支撑服务系统</div>
            <div className='Home_SpaceBasedPlan_FirstMain'>
                <div className='Home_SpaceBasedPlan_MainIntroduceText'>共性应用技术支撑服务系统具备“一站式”服务能力，面向行业、区域、科教、大众等用户，提供地面真值数据共享、产品检验与共享、技术测评与共享、资源共享与培训等服务，形成多模式综合服务体系，具备“互联网+”的遥感协同应用能力、遥感“海量”数据集群化快速处理能力、“互联网+天基”的实地遥感即时服务能力。</div>
            </div>
            <div className='Home_SpaceBasedPlan_Imgs2'>
                <img className='Home_SpaceBasedPlan_Img4' src="images/Introduce/CommonAppSupport/4.png" />
            </div>
        </div>
    )
}